import React, { useEffect, useState } from 'react';
import { datadogLogs } from '@datadog/browser-logs';
import FeatureFlag from '../lib/feature-flags';
import { FeatureFlags } from '../lib/feature-flags';

const FeatureFlagsContext = React.createContext<FeatureFlags>({});

const FeatureFlagsContextProvider = ({
  children,
  appEnv,
  userId,
}: {
  children: React.ReactNode;
  appEnv: 'dev' | 'prod';
  userId?: string;
}) => {
  const [featureFlags, setFeatureFlags] = useState<FeatureFlags>({});
  useEffect(() => {
    const getFeatureFlags = async () => {
      const featureFlagInstance = FeatureFlag.getInstance(appEnv, userId);
      try {
        const flags = await featureFlagInstance.getFlags();
        setFeatureFlags(flags || {});
      } catch (error: any) {
        datadogLogs.logger.error(
          'Error fetching feature flags in FeatureFlagsContext in feature-flag',
          {},
          error,
        );
      }
    };
    getFeatureFlags();
  }, []);

  return (
    <FeatureFlagsContext.Provider value={featureFlags}>{children}</FeatureFlagsContext.Provider>
  );
};

const useFeatureFlagContext = () => {
  const context = React.useContext(FeatureFlagsContext);
  return context;
};

export { FeatureFlagsContextProvider, useFeatureFlagContext };
